import styled from "styled-components";
import Paper from "@mui/material/Paper";
import { Box, InputBase } from "@mui/material";
import { theme } from "styles/mui-config";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";

export const StyledButton = styled(Button)`
  height: 45px;
`;

export const StyledButton2 = styled(Button)`
  height: 45px;

  @media (max-width: 470px) {
    margin-right: 0px !important;
    margin-top: 10px !important;
    width: 100% !important;
  }
`;

export const StyledRadioBtn = styled(Radio)`
  margin-left: 2px !important;
  margin-right: 5px !important;
  @media (max-width: 400px) {
    margin-right: 2px !important;
  }
`;

export const StyledPaper = styled(Paper)`
  padding: 10px;
  margin-bottom: 20px;
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const StyledTitle = styled.div`
  padding: 10px;
  font-family: "Avini";
  display: flex;
  align-items: center;
  font-size: 25px;
  color: ${theme.palette.primary.darkText};
  & > span {
    margin-right: 10px;
  }
  & > svg {
    font-size: 34px;
  }
  @media (max-width: 900px) {
    font-size: 22px;
    & > span {
      margin-right: 6px;
    }
    & > svg {
      font-size: 27px;
    }
  }
  @media (max-width: 400px) {
    padding: 0px;
    font-size: 15px;
    & > svg {
      font-size: 20px;
    }
  }
`;

export const StyledPrice = styled.div`
  padding: 10px;
  font-family: "Avini";
  font-size: 25px;
  color: ${theme.palette.primary.dark};

  span {
    color: #2f849b;
  }

  @media (max-width: 900px) {
    font-size: 22px;
  }
  @media (max-width: 400px) {
    padding: 0px;
    font-size: 15px;
  }
`;

export const StyledPaperDiscount = styled(Paper)`
  padding: 10px;
  margin-bottom: 20px;
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @media (max-width: 750px) {
    & > div:first-child {
      flex-direction: column;
      align-items: start;
    }
  }
`;

export const StyledDiscount = styled.div`
  font-family: "Avini";
  font-size: 25px;
  color: ${theme.palette.primary.dark};
  margin-left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 750px) {
    display: block;
    width: 100%;
    margin-left: 0px;
    justify-content: end;
    display: flex;
  }
  @media (max-width: 470px) {
    margin-top: 10px;
    flex-direction: column;
    & > div:first-child {
      width: 100% !important;
    }
  }
`;
